import { useEffect, useState } from "react";
import { bemCN } from "../../config/bem-classname";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import "./recovery-password-page.scss";
import { ReactComponent as MessageIcon } from "../../shared/images/svg/message.svg";
import { ReactComponent as LockIcon } from "../../shared/images/svg/lock.svg";
import { Input, TypeDataInput, TypeViewInput } from "../../ui/input/input";
import { Link, useNavigate } from "react-router";
import { links } from "../../config/links";
import {
  emailHasError,
  nameHasError,
  passwordHasError,
} from "../../utils/validation-input";
import { ResetCodeRequestDTO, UpdatePasswordRequestDTO } from "../../api/Api";
import { authService } from "../../services/auth-service";

const recoveryPassworPageCn = bemCN("recovery-password-page");

export const RecoveryPasswordPage = () => {
  const [isShowSecondView, setIsShowSecondView] = useState(false);
  const [email, setEmail] = useState<ResetCodeRequestDTO>({ email: "" });
  const [password, setPassword] = useState<UpdatePasswordRequestDTO>({
    email: "",
    code: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isDisableButton, setIsDisableButtno] = useState(false);
  const [errorText, setErrorText] = useState<string>();
  const navigate = useNavigate();

  const onClickSendRequestForRecovery = () => {
    setErrorText(undefined);
    authService.sendCodeRecoveryPassword(email).then((res: any) => {
      if (res == 200) {
        setIsShowSecondView(true);
        password.email = email.email;
      } else {
        setErrorText(res);
      }
    });
  };

  const onClickRecoveryPassword = () => {
    setErrorText(undefined);

    authService.recoveryPassword(password).then((res: any) => {
      if (res == 200) {
        navigate(links.login);
      } else {
        setErrorText(res);
      }
    });
  };

  useEffect(() => {
    if (
      !passwordHasError(password.newPassword) &&
      !passwordHasError(password.confirmPassword) &&
      password.newPassword == password.confirmPassword
    ) {
      setIsDisableButtno(true);
    } else {
      setIsDisableButtno(false);
    }
  }, [password]);

  return (
    <div className={recoveryPassworPageCn()}>
      <h1>
        {isShowSecondView ? "Установите новый пароль" : "Восстановление пароля"}
      </h1>
      {isShowSecondView ? (
        <>
          <div className={recoveryPassworPageCn("inputs")}>
            <Input
              onChange={(v: string) => setPassword({ ...password, code: v })}
              icon={<MessageIcon />}
              placeholder="Код из письма"
              value={password.code}
              typeView={TypeViewInput.text}
              typeData={TypeDataInput.text}
            />

            <Input
              icon={<LockIcon />}
              placeholder="Новый пароль"
              value={password.newPassword}
              typeView={TypeViewInput.password}
              typeData={TypeDataInput.password}
              onChange={(v: string) =>
                setPassword({ ...password, newPassword: v })
              }
              isValidate
            />
            <Input
              icon={<LockIcon />}
              placeholder="Повторите пароль"
              value={password.confirmPassword}
              typeView={TypeViewInput.password}
              typeData={TypeDataInput.password}
              onChange={(v: string) =>
                setPassword({ ...password, confirmPassword: v })
              }
              isValidate
            />
          </div>

          <Button
            onClick={onClickRecoveryPassword}
            text="Подтвердить"
            color={ButtonColors.green}
            size={ButtonSizes.big}
            noDisabled={!isDisableButton}
          />
        </>
      ) : (
        <div className={recoveryPassworPageCn("inputs")}>
          <Input
            onChange={(v: string) => setEmail({ ...email, email: v })}
            icon={<MessageIcon />}
            placeholder="Email"
            value={email.email}
            typeView={TypeViewInput.text}
            typeData={TypeDataInput.email}
            isValidate
          />
          <Button
            onClick={onClickSendRequestForRecovery}
            text="Восстановить"
            color={ButtonColors.violet}
            size={ButtonSizes.big}
            noDisabled={emailHasError(email.email) ? true : false}
          />
        </div>
      )}
      {errorText && <p>{errorText}</p>}
      <div className={recoveryPassworPageCn("links")}>
        <Link to={links.reg}>Зарегистрироваться</Link>
        <Link to={links.login}>Войти</Link>
      </div>
    </div>
  );
};
